<template>
	<div class="projectplan-style">
		<headerNav title="选材单" leftNav="返回" @leftClick="back"></headerNav>
		<div class="content-style">
			<!-- <pullRefresh ref="pullRefresh" @refresh="onRefresh"> -->
				<!-- 加载中 -->
				<div style="height: calc(100vh - 55px);display: flex;align-items: center;justify-content: center;" v-if="loading">
					<van-loading size="24px" vertical>加载中，请稍后...</van-loading>
				</div>
				<div class="pullRefresh-style" v-else>
					<!-- 自定义暂无数据 -->
					<div class="empty" v-if="!list.length">
						<img src="../../../../assets/uf23.png" alt="" style="width: 100%;">
						<div class="empty-text">暂无内容</div>
					</div>
					<!-- table -->
					<el-table :data="list" style="width: 100%" height="calc(100vh - 88px)" row-class-name="market-row" row-key="id"
						:tree-props="{ children: 'children' }" @cell-click="cellClick" @row-click="rowClick"
						@expand-change="expandChange" :header-cell-style="{ background: '#f2f2f2', height: '48px' }"
						:row-style="{ height: '48px' }" ref="elTable" v-else>
						<el-table-column prop="parentName" label="项目名称" width="200">
							<template slot-scope="scope">
								<div v-if="scope.row.parentId === '-1'">
									<img src="../../../../assets/uf24.png" alt="" style="width: 12px;">&nbsp;
									<span style="color: #FF8450;">{{ scope.row.parentName }}</span>
								</div>
								<div v-else class="van-ellipsis" style="width: 100%;max-width: 144px;">{{ scope.row.propertyName }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="productItemName" label="材料名称" width="160">
							<template slot-scope="scope">
								<div class="van-ellipsis" style="width: 100%;max-width: 136px;color: #0084F4;">
									{{ scope.row.productItemName }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="brandName" label="材料品牌" width="130">
							<template slot-scope="scope">
								<span v-if="scope.row.parentId !== '-1'" class="van-ellipsis" style="width: 100%;max-width: 104px;">
									{{ scope.row.brandName }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="productModelSpec" label="型号/尺寸" width="250">
							<template slot-scope="scope">
								<span v-if="scope.row.parentId !== '-1'" class="van-ellipsis" style="width: 100%;max-width: 224px;">
									<div>{{ scope.row.productModelSpec }}</div>
									<div v-if="scope.row.itemSize">{{ scope.row.itemSize }}</div>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="totalQuantity" label="实际量" align="right" width="130">
							<template slot-scope="scope">
								<span v-if="scope.row.parentId !== '-1'" class="tr">{{ scope.row.totalQuantity }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="productRemark" label="说明" width="250">
							<template slot-scope="scope">
								<span v-if="scope.row.parentId !== '-1'" style="width: 100%;max-width: 224px;">
									{{ scope.row.productRemark }}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			<!-- </pullRefresh> -->
		</div>

		<van-dialog v-model="show" :showConfirmButton="false">
			<template #title>
				<div style="padding: 12px 0;border-bottom: 1px solid #eee;">材料详情</div>
				<div class="dialog-close" @click="dialogClose">
					<img src="@/assets/close.png" alt="" width="100%">
				</div>
			</template>
			<div class="dialog-style">
				<div class="dialog-row">
					<div class="dialog-lab">材料名称：</div>
					<div class="dialog-val">{{ dialogData.itemName }}</div>
				</div>
				<div class="dialog-row">
					<div class="dialog-lab">材料编码：</div>
					<div class="dialog-val">{{ dialogData.itemNo }}</div>
				</div>
				<div class="dialog-row">
					<div class="dialog-lab">单位：</div>
					<div class="dialog-val">{{ dialogData.unitName }}</div>
				</div>
				<div class="dialog-row">
					<div class="dialog-lab">客户价（元）：</div>
					<div class="dialog-val">{{ dialogData.sellingPrice }}</div>
				</div>
				<div class="dialog-row">
					<div class="dialog-lab">套餐类型：</div>
					<div class="dialog-val">{{ dialogData.allianceName }}</div>
				</div>
				<div class="dialog-row">
					<div class="dialog-lab">材料说明：</div>
					<div class="dialog-val">{{ dialogData.remark }}</div>
				</div>
			</div>
		</van-dialog>

		<upBtn />
	</div>
</template>

<script>
import api from '@/api/api.js'
import upBtn from './upBtn.vue'
export default {
	components: {
		upBtn
	},
	data() {
		return {
			list: [],
			info: {},
			typeInfo: {},
			expandList: [],
			show: false,
			dialogData: {},
			loading: false,
		}
	},
	methods: {
		back() {
			this.$router.push({ name: "deepenClicntDetailName", })
		},
		//获取列表
		async getList() {
			try {
				this.loading = true
				const { data } = await api.getMaterialSheetList(this.typeInfo.budgetInfoId)
				this.list = data ?? []
			} finally {
				this.loading = false
			}
		},
		async cellClick(row, column) {
			try {
				if (column.label === '材料名称' && row.parentId !== '-1' && row.productItemName?.length) {
					this.dialogData = { itemName: row.productItemName, itemNo: row.productItemNo }
					const { data } = await api.getMaterialsList({ Q_itemNo_LK: row.productItemNo })
					if (data.length){
						this.dialogData = data[0]
					}
					this.show = true
				} else {
					this.dialogData = {}
				}
			} catch (error) {
				
			}
		},
		rowClick(row) {
			if (row.parentId === '-1' && row.children?.length) {
				const flag = this.expandList.includes(row.id)
				if (flag) {
					this.$refs.elTable.toggleRowExpansion(row, false);
					this.expandList = this.expandList.filter(item => item !== row.id)
				} else {
					this.$refs.elTable.toggleRowExpansion(row, true);
					this.expandList.push(row.id)
				}
			}
		},
		expandChange(row, expanded) {
			if (expanded) {
				this.expandList = Array.from(new Set([...this.expandList, row.id]))
			} else {
				this.expandList = this.expandList.filter(item => item !== row.id)
			}
		},
		dialogClose() {
			const aa = document.querySelector('.dialog-style')
			aa?.scrollTo({ top: '0', behavior: 'smooth' })
			this.show = false
		},
		onRefresh() {
			this.list = [];
			this.getList();
		},
	},
	mounted() {
		this.info = JSON.parse(sessionStorage.getItem('clientInfo'))
		this.typeInfo = JSON.parse(sessionStorage.getItem('clientTypeInfo'))
		this.getList();
	},
}
</script>

<style scoped lang="scss">
.projectplan-style {
	.tr {
		width: 100%;
		text-align: right;
	}

	.content-style {
		height: calc(100vh - 50px);
		overflow: auto;

		.pullRefresh-style {
			min-height: calc(100vh - 66px);
		}

		.empty {
			min-height: calc(100vh - 90px);
			background: #fff;
			padding-top: 40px;

			.empty-text {
				text-align: center;
				font-size: 18px;
				font-family: PingFang SC, PingFang SC;
				color: #5E5E5E;
				margin-top: 10px;
				height: 100%;
			}
		}

		.table {
			font-size: 18px;
		}
	}

	::v-deep .van-dialog__header {
		padding-top: 0;
	}

	::v-deep .van-dialog__content {
		padding: 8px 0;
	}

	::v-deep .cell {
		display: flex;
	}

	::v-deep .van-dialog {
		border-radius: 8px;
	}

	.dialog-close {
		width: 30px;
		height: 30px;
		position: absolute;
		top: 8px;
		right: 16px;
	}

	.dialog-style {
		font-size: 16px;
		padding: 0 16px;
		text-align: left;
		max-height: 50vh;
		overflow-y: auto;

		.dialog-row {
			margin-bottom: 16px;
			display: flex;

			.dialog-lab {
				color: #888;
			}

			.dialog-val {
				flex: 1;
				word-wrap: break-word;
				word-break: break-all;
			}
		}
	}
}
</style>
